<template>
  <b-button v-if="visible" size="sm" variant="primary" :to="{ name: 'vehicle_status_history' }" aria-label="VSM History">
    <i class="fa fa-history"></i>
  </b-button>
</template>

<script>
import { mapState } from 'vuex'
import { hasVsmHistoryAccess } from '../utils/vsm_access'
import vsmMobileView from '@/mixins/vsm_mobile_view'

export default {
  name: 'VsmHistoryLinkButton',
  // hidden on narrow/card-layout views to keep the chip strip to one row
  mixins: [vsmMobileView],
  computed: {
    ...mapState({ user: state => state.profile.user }),
    visible() { return hasVsmHistoryAccess(this.user) && !this.mobileView },
  },
}
</script>
